import * as styles from './GroupTitle.scss';
import { Icon, IconCitySolid, IconTimeSolid } from 'app/icons';
import React from 'react';

export const GroupTitle = ({
  group,
  title,
}: {
  group: 'recent' | 'popular' | string;
  title: string;
}) => {
  const showIcon = group === 'recent' || group === 'popular';
  const icon = group === 'popular' ? IconCitySolid : IconTimeSolid;

  return (
    <span role="presentation" className={styles.continent}>
      {showIcon && (
        <span aria-hidden>
          <Icon appearance="primary" InlineIcon={icon} extraClasses={styles.titleIcon} />
        </span>
      )}
      {title}
    </span>
  );
};
